import angular from 'angular';
import OneRosterApiService from './oneRosterApi.service';

let OneRosterApiModule = angular.module('oneRosterApi', []).service('oneRosterApiService', OneRosterApiService);

export
default OneRosterApiModule;



// WEBPACK FOOTER //
// ./app/common/oneRosterApi/oneRosterApi.js